export var DocumentMimeType;
(function (DocumentMimeType) {
    DocumentMimeType["HTML"] = "text/html";
    DocumentMimeType["MS_WORD_DOCUMENT"] = "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
})(DocumentMimeType || (DocumentMimeType = {}));
//# sourceMappingURL=Enums.js.map